import { render, staticRenderFns } from "./RHBForm.vue?vue&type=template&id=0b0f06e8"
import script from "./RHBForm.vue?vue&type=script&lang=js"
export * from "./RHBForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports